import clsx from 'clsx';
import { PropsWithChildren } from 'react';

interface Props {
  badgeColor?:
    | 'text-primary'
    | 'text-success'
    | 'text-info'
    | 'text-warning'
    | 'text-danger'
    | 'text-muted';
  badgeType?: 'donut';
  hideLine?: boolean;
}

export default function TimelineWithoutDate({
  badgeColor = 'text-primary',
  badgeType = 'donut',
  hideLine = false,
  children,
}: PropsWithChildren<Props>) {
  const badgeSize: Record<typeof badgeType, string> = {
    donut: '18px',
  };

  return (
    <div className='d-flex position-relative'>
      {/* Vertical line */}
      {!hideLine && (
        <div
          className='position-absolute rounded'
          style={{
            left: `calc(${badgeSize[badgeType]} / 2)`,
            top: '0',
            bottom: '1px',
            width: '3px',
            backgroundColor: 'var(--bs-gray-200)',
            zIndex: 0,
            transform: 'translate(-50%)',
          }}
        ></div>
      )}

      {/* Badge container */}
      <div
        className='me-3 flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle bg-white border border-4 border-white'
        style={{ width: badgeSize[badgeType], height: badgeSize[badgeType], zIndex: 1 }}
      >
        {badgeType === 'donut' && <i className={clsx('fa fa-genderless fs-1', badgeColor)} />}
      </div>

      {/* Content */}
      <div className={clsx('flex-grow-1')}>{children}</div>
    </div>
  );
}
